import React, { Dispatch, SetStateAction } from "react";
import styled from 'styled-components';

type RadioButtonFieldComponentProps = {
  selection: Array<{
    label: string;
    value: string;
  }>,
  mb?: string;
  checkedValue: string;
  setCheckedValueAction: Dispatch<SetStateAction<string>>
}

const RadioButtonStyle = styled.div<{$mb?: string}>`
  display: flex;
  color: #383432;
  text-align: left;
  margin-left: 0;
  margin-bottom: ${props => props.$mb || '0'};
    
  label {
    margin-right: 10px;
  }

  input[type="radio"] {
    position: relative;
    width: 16px;
    height: 16px;
    border: 1px solid #383432;
    border-radius: 50%;
    vertical-align: -2px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
  }

  input[type="radio"]:checked:before {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 9px;
    height: 9px;
    border-radius: 50%;
    background: #383432;
    content: '';
  }
`;

const RadioButtonField: React.FC<RadioButtonFieldComponentProps> = ({ selection, mb, checkedValue, setCheckedValueAction }) => {

  return (
    <RadioButtonStyle $mb={mb}>
      {selection.map((item, index) => (
        <div key={index}>
          <input type='radio' id={item.value} name={item.value} value={item.value} checked={checkedValue === item.value} onChange={() => setCheckedValueAction(item.value)} />
          <label htmlFor={item.value}>{ item.label }</label>
        </div>
      ))}
    </RadioButtonStyle>
  );
};

export default RadioButtonField;
